import { graphql, useStaticQuery } from 'gatsby';

import { DEFAULT_EXCLUDED_PAGES, DEFAULT_NAME_OVERRIDE } from './constants';
import { SiteNode, SitePageQueryResult, TreeItem, UseSiteTreeParams } from './model';
import { createTree } from './utils';

const useSiteTree = ({
  lang = null,
  exclude = DEFAULT_EXCLUDED_PAGES,
  nameOverride = DEFAULT_NAME_OVERRIDE,
}: UseSiteTreeParams = {}): TreeItem[] => {
  const { allSitePage }: SitePageQueryResult = useStaticQuery(graphql`
    query AllSitePageQuery {
      allSitePage {
        nodes {
          id
          path
          context {
            lang
            name
          }
        }
      }
    }
  `);

  const nodes: SiteNode[] = allSitePage.nodes
    .filter((item) => {
      const LANG_NON_DEFINED = null;

      if (item.context?.lang && lang) {
        return [lang, LANG_NON_DEFINED].includes(item.context?.lang);
      }

      return true;
    })
    .map(({ id, path, context }) => ({
      name: context?.name,
      id,
      path,
    }));

  return createTree({
    nodes,
    exclude,
    nameOverride,
  });
};

export default useSiteTree;
